module.exports = __webpack_public_path__ + "static/media/AIR_AMS_TYPE86_GUIDE.1b4ddb68.xlsx";